import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C6B8442F-446D-4690-866F-AF0F27C1EAB2
 * name close-thick
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-thick.svg
 * tags
 */
export const CloseThickIcon = createSvgIcon(<><path d="M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z" /></>, 'CloseThickIcon');
export default CloseThickIcon